<div id="job-search-filters-mobile-menu" [@slideInOut]="mobileFilterMenuState"  (@slideInOut.done)="toggleBodyOverflow()">
    <div class="container-fluid">

        <div id="job-search-filters-mobile-menu-top" class="row" [style.background-color]="themeColor"></div>

        <div id="job-search-filters-mobile-menu-header" class="row">
            <a>
                <i class="icon icon-close-thick" (click)="toggleMobileFilterMenu()"></i>
            </a>
        </div>

        <div id="job-search-filters-mobile-menu-content" class="row">


            <div class="col-xs-12">


                    <form class="filter-container" *ngFor="let availableFilter of availableFilters; let filtersIndex = index">

                        <div id="{{availableFilter.className}}-mobile-group" class="filter-option">{{availableFilter.headline}}</div>

                        <div class="{{availableFilter.type}}" *ngFor="let options of availableFilter.options; let optionsIndex = index">
                            <label>
                                <input
                                    type="{{availableFilter.type}}"
                                    name="{{availableFilter.className}}-mobile-group"
                                    value="{{options.value}}"
                                    [attr.aria-labelledby]="availableFilter.className + '-mobile-group'"
                                    [checked]="options.selected === true"
                                    (change)="onSelectionChange(filtersIndex, optionsIndex)">
                                <span>{{options.displayName}}</span>
                            </label>
                        </div>

                    </form>


            </div>

        </div>

    </div>

</div>


<div id="job-search-filters-mobile-menu-footer" [@slideInOut]="mobileFilterMenuState" class="container">
    <div class="row">
        <div class="col-xs-6">
            <button class="btn btn-secondary btn-block" (click)="resetFiltersHandler()">Reset Filters</button>
        </div>
        <div class="col-xs-6">
            <button class="btn btn-primary btn-block" [style.background-color]="themeColor" (click)="applyFiltersHandler()">Apply filters</button>
        </div>
    </div>
</div>

